module.exports = __webpack_public_path__ + "static/n1_large-202bc2a3576217866973ecf73b76270d.jpg";